import { useNavigate } from 'react-router-dom';
import { DsButton } from '@/modules/internal-v2/ds';
import { BASE } from '../config/routes';

interface ForbiddenPageProps {
  title?: string;
  message?: string;
}

/** 403 screen shown when the current user lacks the required permission. */
export function ForbiddenPage({ title, message }: ForbiddenPageProps) {
  const navigate = useNavigate();

  return (
    <div className="v2-forbidden">
      <div className="v2-forbidden-code">403</div>
      <h1 className="v2-forbidden-title">{title ?? 'Kein Zugriff'}</h1>
      <p className="v2-forbidden-text">
        {message ??
          'Du hast keine Berechtigung, diesen Bereich anzuzeigen. Wende dich an einen Administrator, wenn du Zugriff benötigst.'}
      </p>
      <DsButton variant="primary" onClick={() => navigate(BASE)}>
        Zum Dashboard
      </DsButton>
    </div>
  );
}
